import OrdersCampaignItem from "./OrdersCampaignItem";

export default OrdersCampaignItem;